/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AcceptInvitationRequest,
  ClearBranchRequest,
  CreateAccountRequest,
  CreateAccountResponse,
  DeleteUserRequest,
  GetCouponResponse,
  GetReferralCodeResponse,
  Invitation,
  LookUpEmailResponse,
  RequestPasswordResetRequest,
  ResendInvitationRequest,
  ResetPasswordRequest,
  RevokeInvitationRequest,
  SendInvitationRequest,
  SendInvitationResponse,
  SetBranchRequest,
  SharePrefilledInfoRequest,
  SwitchToLinkedCompanyRequest,
  SwitchToLinkedCompanyResponse,
  UpdateUserRequest,
  User,
  UserInfo,
} from '../models/index';
import {
    AcceptInvitationRequestFromJSON,
    AcceptInvitationRequestToJSON,
    ClearBranchRequestFromJSON,
    ClearBranchRequestToJSON,
    CreateAccountRequestFromJSON,
    CreateAccountRequestToJSON,
    CreateAccountResponseFromJSON,
    CreateAccountResponseToJSON,
    DeleteUserRequestFromJSON,
    DeleteUserRequestToJSON,
    GetCouponResponseFromJSON,
    GetCouponResponseToJSON,
    GetReferralCodeResponseFromJSON,
    GetReferralCodeResponseToJSON,
    InvitationFromJSON,
    InvitationToJSON,
    LookUpEmailResponseFromJSON,
    LookUpEmailResponseToJSON,
    RequestPasswordResetRequestFromJSON,
    RequestPasswordResetRequestToJSON,
    ResendInvitationRequestFromJSON,
    ResendInvitationRequestToJSON,
    ResetPasswordRequestFromJSON,
    ResetPasswordRequestToJSON,
    RevokeInvitationRequestFromJSON,
    RevokeInvitationRequestToJSON,
    SendInvitationRequestFromJSON,
    SendInvitationRequestToJSON,
    SendInvitationResponseFromJSON,
    SendInvitationResponseToJSON,
    SetBranchRequestFromJSON,
    SetBranchRequestToJSON,
    SharePrefilledInfoRequestFromJSON,
    SharePrefilledInfoRequestToJSON,
    SwitchToLinkedCompanyRequestFromJSON,
    SwitchToLinkedCompanyRequestToJSON,
    SwitchToLinkedCompanyResponseFromJSON,
    SwitchToLinkedCompanyResponseToJSON,
    UpdateUserRequestFromJSON,
    UpdateUserRequestToJSON,
    UserFromJSON,
    UserToJSON,
    UserInfoFromJSON,
    UserInfoToJSON,
} from '../models/index';

export interface AcceptInvitationOperationRequest {
    acceptInvitationRequest?: AcceptInvitationRequest;
}

export interface ClearBranchOperationRequest {
    clearBranchRequest?: ClearBranchRequest;
}

export interface CreateAccountOperationRequest {
    createAccountRequest?: CreateAccountRequest;
}

export interface DeleteUserOperationRequest {
    deleteUserRequest?: DeleteUserRequest;
}

export interface LookUpEmailRequest {
    email: string;
}

export interface RequestPasswordResetOperationRequest {
    requestPasswordResetRequest?: RequestPasswordResetRequest;
}

export interface ResendInvitationOperationRequest {
    resendInvitationRequest?: ResendInvitationRequest;
}

export interface ResetPasswordOperationRequest {
    resetPasswordRequest?: ResetPasswordRequest;
}

export interface RevokeInvitationOperationRequest {
    revokeInvitationRequest?: RevokeInvitationRequest;
}

export interface SendInvitationOperationRequest {
    sendInvitationRequest?: SendInvitationRequest;
}

export interface SetBranchOperationRequest {
    setBranchRequest?: SetBranchRequest;
}

export interface SharePrefilledInfoOperationRequest {
    sharePrefilledInfoRequest?: SharePrefilledInfoRequest;
}

export interface SwitchToLinkedCompanyOperationRequest {
    switchToLinkedCompanyRequest?: SwitchToLinkedCompanyRequest;
}

export interface UpdateRequest {
    updateUserRequest?: UpdateUserRequest;
}

/**
 * 
 */
export class UsersApi extends runtime.BaseAPI {

    /**
     * 
     */
    async acceptInvitationRaw(requestParameters: AcceptInvitationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/users/accept-invitation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AcceptInvitationRequestToJSON(requestParameters['acceptInvitationRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async acceptInvitation(requestParameters: AcceptInvitationOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.acceptInvitationRaw(requestParameters, initOverrides);
    }

    /**
     * 
     */
    async clearBranchRaw(requestParameters: ClearBranchOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<User>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/users/clear-branch`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClearBranchRequestToJSON(requestParameters['clearBranchRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
    }

    /**
     * 
     */
    async clearBranch(requestParameters: ClearBranchOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<User> {
        const response = await this.clearBranchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create an account
     */
    async createAccountRaw(requestParameters: CreateAccountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateAccountResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/users/create-account`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateAccountRequestToJSON(requestParameters['createAccountRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateAccountResponseFromJSON(jsonValue));
    }

    /**
     * Create an account
     */
    async createAccount(requestParameters: CreateAccountOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateAccountResponse> {
        const response = await this.createAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async deleteAccountRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/users/delete-account`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async deleteAccount(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAccountRaw(initOverrides);
    }

    /**
     * 
     */
    async deleteUserRaw(requestParameters: DeleteUserOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/users/delete`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DeleteUserRequestToJSON(requestParameters['deleteUserRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async deleteUser(requestParameters: DeleteUserOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteUserRaw(requestParameters, initOverrides);
    }

    /**
     * Your GET endpoint
     */
    async getCouponRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCouponResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/users/get-coupon`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCouponResponseFromJSON(jsonValue));
    }

    /**
     * Your GET endpoint
     */
    async getCoupon(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCouponResponse> {
        const response = await this.getCouponRaw(initOverrides);
        return await response.value();
    }

    /**
     * Your GET endpoint
     */
    async getReferralCodeRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetReferralCodeResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/users/get-referral-code`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetReferralCodeResponseFromJSON(jsonValue));
    }

    /**
     * Your GET endpoint
     */
    async getReferralCode(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetReferralCodeResponse> {
        const response = await this.getReferralCodeRaw(initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async listForCompanyRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<User>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/users/list-for-company`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserFromJSON));
    }

    /**
     * 
     */
    async listForCompany(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<User>> {
        const response = await this.listForCompanyRaw(initOverrides);
        return await response.value();
    }

    /**
     * Your GET endpoint
     */
    async listInvitationsForCompanyRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Invitation>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/users/list-invitations-for-company`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InvitationFromJSON));
    }

    /**
     * Your GET endpoint
     */
    async listInvitationsForCompany(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Invitation>> {
        const response = await this.listInvitationsForCompanyRaw(initOverrides);
        return await response.value();
    }

    /**
     * Looks up if the email is already used
     * Your GET endpoint
     */
    async lookUpEmailRaw(requestParameters: LookUpEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LookUpEmailResponse>> {
        if (requestParameters['email'] == null) {
            throw new runtime.RequiredError(
                'email',
                'Required parameter "email" was null or undefined when calling lookUpEmail().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['email'] != null) {
            queryParameters['email'] = requestParameters['email'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/users/look-up-email`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LookUpEmailResponseFromJSON(jsonValue));
    }

    /**
     * Looks up if the email is already used
     * Your GET endpoint
     */
    async lookUpEmail(requestParameters: LookUpEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LookUpEmailResponse> {
        const response = await this.lookUpEmailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async requestPasswordResetRaw(requestParameters: RequestPasswordResetOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/users/request-password-reset`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestPasswordResetRequestToJSON(requestParameters['requestPasswordResetRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async requestPasswordReset(requestParameters: RequestPasswordResetOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.requestPasswordResetRaw(requestParameters, initOverrides);
    }

    /**
     * 
     */
    async resendInvitationRaw(requestParameters: ResendInvitationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SendInvitationResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/users/resend-invitation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ResendInvitationRequestToJSON(requestParameters['resendInvitationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SendInvitationResponseFromJSON(jsonValue));
    }

    /**
     * 
     */
    async resendInvitation(requestParameters: ResendInvitationOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SendInvitationResponse> {
        const response = await this.resendInvitationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async resetPasswordRaw(requestParameters: ResetPasswordOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/users/reset-password`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ResetPasswordRequestToJSON(requestParameters['resetPasswordRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async resetPassword(requestParameters: ResetPasswordOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.resetPasswordRaw(requestParameters, initOverrides);
    }

    /**
     * 
     */
    async revokeInvitationRaw(requestParameters: RevokeInvitationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/users/revoke-invitation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RevokeInvitationRequestToJSON(requestParameters['revokeInvitationRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async revokeInvitation(requestParameters: RevokeInvitationOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.revokeInvitationRaw(requestParameters, initOverrides);
    }

    /**
     * 
     */
    async sendInvitationRaw(requestParameters: SendInvitationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SendInvitationResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/users/send-invitation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendInvitationRequestToJSON(requestParameters['sendInvitationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SendInvitationResponseFromJSON(jsonValue));
    }

    /**
     * 
     */
    async sendInvitation(requestParameters: SendInvitationOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SendInvitationResponse> {
        const response = await this.sendInvitationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async setBranchRaw(requestParameters: SetBranchOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<User>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/users/set-branch`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SetBranchRequestToJSON(requestParameters['setBranchRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
    }

    /**
     * 
     */
    async setBranch(requestParameters: SetBranchOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<User> {
        const response = await this.setBranchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Share Prefilled Info
     */
    async sharePrefilledInfoRaw(requestParameters: SharePrefilledInfoOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/users/share-prefilled-info`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SharePrefilledInfoRequestToJSON(requestParameters['sharePrefilledInfoRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Share Prefilled Info
     */
    async sharePrefilledInfo(requestParameters: SharePrefilledInfoOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.sharePrefilledInfoRaw(requestParameters, initOverrides);
    }

    /**
     * Switches the user to another linked company without logout
     * Switch to Linked Company
     */
    async switchToLinkedCompanyRaw(requestParameters: SwitchToLinkedCompanyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SwitchToLinkedCompanyResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/users/switch-to-linked-company`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SwitchToLinkedCompanyRequestToJSON(requestParameters['switchToLinkedCompanyRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SwitchToLinkedCompanyResponseFromJSON(jsonValue));
    }

    /**
     * Switches the user to another linked company without logout
     * Switch to Linked Company
     */
    async switchToLinkedCompany(requestParameters: SwitchToLinkedCompanyOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SwitchToLinkedCompanyResponse> {
        const response = await this.switchToLinkedCompanyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async updateRaw(requestParameters: UpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<User>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/users/update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateUserRequestToJSON(requestParameters['updateUserRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
    }

    /**
     * 
     */
    async update(requestParameters: UpdateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<User> {
        const response = await this.updateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets the current user info
     * Get User Info
     */
    async userInfoRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserInfo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/users/user-info`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserInfoFromJSON(jsonValue));
    }

    /**
     * Gets the current user info
     * Get User Info
     */
    async userInfo(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserInfo> {
        const response = await this.userInfoRaw(initOverrides);
        return await response.value();
    }

}
